import styled from 'styled-components/macro';

import { hexToRGB } from '@repo-level/core-front';

export const ScPaymentMethod = styled.div`
  h2 {
    text-transform: uppercase;
    margin-bottom: 16px;
  }

  .profiles {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    margin: 24px 0;
    gap: 8px;

    .profile {
      cursor: pointer;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      background-color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.2)};
      padding: 12px 8px;
      border-radius: 4px;
      border: 2px solid ${({ theme }) => hexToRGB(theme.whiteColor, 0.3)};

      text-align: center;

      font-size: 14px;
      font-weight: 700;
      line-height: 20px;

      &.active {
        border: 2px solid ${({ theme }) => theme.greenColor};
      }
    }
  }

  .permission {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 24px;
  }

  .warn_ico {
    margin-bottom: -5px;
    margin-right: 5px;
  }

  p {
    font-size: 16px;
    line-height: 1.5;
    margin-top: 16px;
  }

  .deposit-button {
    button {
      margin-top: 16px;
    }
  }

  .remove-btn {
    margin: 16px auto 0;
    width: fit-content;

    cursor: pointer;
    color: ${({ theme }) => theme.grayColor1};
    text-align: center;
    font-size: 12px;
    line-height: 130%;
    text-decoration-line: underline;
  }
`;
